import React, { useState, useEffect } from 'react';
import "jspdf-autotable";
import ApiService, { userCode, username } from '../../../services/ApiService';
import CreateEditJobType from './CreateEditJobType';
import TempListMaster from '../TempListMaster';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { Backdrop } from '@mui/material';
import LoadingSpinner from '../../../components/Components/LoadingSpinner';
import CustomToastContainer, { showToast } from '../../../components/ui';

const ListJobType = forwardRef((props, ref) => {
  const [isLoadingBackDrop, setIsLoadingBackDrop] = useState(true);
  const [data, setData] = useState([]);
  const [titleModal, setTitleModal] = useState('');
  const title = 'Job Type'
  const [isModal, setIsModal] = useState(false);
  const param = "jobtype/jobtype";
  const [id, setId] = useState(0);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [dataMap, setDataMap] = useState([])
  const [columnData, setColumnData] = useState([])
  const [SelectedData, setSelectedData] = useState({});
  const [totalRows, setTotalRows] = useState(50)
  const [rowsCount, setRowsCount] = useState(50)
  const [numPage, setNumPage] = useState(1)
  const [filter, setFilter] = useState([])
  const [filterBy, setFilterBy] = useState([])
  const [stateX, setStateX] = useState({});
  const [sortArr, setSortArr] = useState([])

  const dataLocal = JSON.parse(localStorage.getItem(username + "-DatajobType"));

  const simpanLocal = () => {
    if (isModal) {
      var data;
      data = {
        "jobType": {
          "rowStatus": "ACT",
          "id": id,
          "code": code,
          "name": name,
          "user": userCode,
          "titleModal": titleModal
        }
      }
      localStorage.setItem(username + "-DatajobType", JSON.stringify(data));
    }
  }

  useImperativeHandle(ref, () => ({

    localSave() {
      simpanLocal()
    }

  }));

  const fetchDataLocal = () => {
    var result = dataLocal.jobType;
    setIsModal(true);
    setCode(result.code);
    setName(result.name);
    setId(result.id);
    setTitleModal(result.titleModal);
    localStorage.removeItem(username + '-DatajobType')
  }

  const toggleAdd = () => {
    setId(0);
    setCode('');
    setName('');
    handleClick();
    setTitleModal('Add');
  }

  const toggleEdit = () => {
    if (SelectedData.id === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' })
    } else {
      ApiService.PostById(param, SelectedData.id).then((res) => {
        if (res !== null) {
          var result = res.data.data.jobType;
          setCode(result.code);
          setName(result.name);
        }
        setId(SelectedData.id);
        setIsModal(true);
        setTitleModal('Edit');
      });
    }
  }

  let countRefresh = 0;

  useEffect(() => {
    if (countRefresh === 0) {
      ApiService.refreshToken();
      countRefresh++;
      if (dataLocal) {
        setTimeout(function () { fetchDataLocal(); }, 2000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = (pageNumber, pageSize, filters, orderBy) => {
    if (isLoadingBackDrop === false) {
      setIsLoading(true);
    } else {
      setIsLoadingBackDrop(true);
    }
    ApiService.DynamicPostByPage(param, 'PAGE', pageNumber, pageSize, [], filters, orderBy)
      .then((response) => {
        if (response.data.code === 200) {
          setSelectedData({})
          setData(response.data.data.jobType);

          let temp = response.data.data.jobType
          let indexed = temp.map((el, index) => {
            let indexedTemp = {
              ...el,
              index
            }
            return indexedTemp
          })

          setDataMap(indexed)
          setColumnData(response.data.data.columns)
          setTotalRows(response.data.totalRowCount)

          setIsLoading(false)
          setIsLoadingBackDrop(false)
        } else {
          setIsLoadingBackDrop(false)
          showToast({ type: 'error', message: 'Error When Fetch Data, Please Contact The Administrator, ' + response.data.message })
        }
        setIsLoading(false)
      })
      .catch(function (error) {
        setIsLoading(false)
        setIsLoadingBackDrop(false)
        console.error('error saat fetch', error)
        showToast({ type: 'error', message: 'Error When Fetch Data, Please Contact The Administrator, ' + error })
      })
  }

  const handleClick = () => {
    if (isModal === false) {
      setIsModal(true);
    } else {
      setIsModal(false);
      setNumPage(1)
      setRowsCount(50)
    }
  };

  function CellDoubleClick(row) {
    toggleEdit()
  }

  return (
    <>
      <CustomToastContainer />
      <TempListMaster
        SelectedData={SelectedData}
        param={param}
        data={data}
        title={title}
        toggleAdd={toggleAdd}
        toggleEdit={toggleEdit}
        isLoading={isLoading}
        getData={getData}
        columnData={columnData}
        dataMap={dataMap}
        setSelectedData={setSelectedData}
        CellDoubleClick={CellDoubleClick}
        totalRows={totalRows}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        numPage={numPage}
        setNumPage={setNumPage}
        filter={filter}
        setFilter={setFilter}
        filterBy={filterBy}
        setFilterBy={setFilterBy}
        stateX={stateX}
        setStateX={setStateX}
        menuCode={'MJOBT'}
        menuName={'MASTER'}
        sortArr={sortArr}
        setSortArr={setSortArr}
      />

      {
        isModal && (
          <CreateEditJobType
            isModal={isModal}
            handleClick={handleClick}
            titleModal={titleModal}
            title={title}
            param={param}
            id={id}
            getData={getData}
            code={code}
            setCode={setCode}
            name={name}
            setName={setName}
          />
        )
      }

      {
        isLoadingBackDrop && (
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoadingBackDrop}
          >
            <LoadingSpinner />
          </Backdrop>
        )
      }
    </>
  )
})

export default ListJobType
